module.exports = __webpack_public_path__ + "img/hide-arrow.66a82009.svg";